import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

// project imports
import AppLayout from 'layout/AppLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';
import { shipmentsRoutes } from 'features/shipments/routes';
import { quotesRoutes } from 'features/quotes/routes';
import { draftsRoutes } from 'features/drafts/routes';
import { paymentsRoutes } from 'features/payments/routes';
import { accountRoutes } from 'features/account/routes';
import { dashboardRoutes } from 'features/dashboard/routes';
import { storageRoutes } from 'features/storage/routes';

// shipment routing — the list/detail/new/edit routes all come from features/shipments/routes,
// quotes from features/quotes/routes, drafts from features/drafts/routes, payments from
// features/payments/routes (all spread below)

// account routing — the /account/* routes and /profile both come from
// features/account/routes; /dashboard from features/dashboard/routes (all spread below)

// ==============================|| AUTHENTICATED ROUTING ||============================== //

const AuthenticatedRoutes: RouteObject = {
  path: '/',
  element: (
    <AuthGuard>
      <AppLayout />
    </AuthGuard>
  ),
  errorElement: <ErrorBoundary />,
  children: [
    ...dashboardRoutes,
    ...shipmentsRoutes,
    ...quotesRoutes,
    ...draftsRoutes,
    ...paymentsRoutes,
    ...accountRoutes,
    ...storageRoutes,
    {
      path: '*',
      element: <Navigate to="/dashboard" replace />
    }
  ]
};

export default AuthenticatedRoutes;
